import { ContentCard, Row } from "@narmi/design_system";
import styles from "./OrganizationRoles.module.scss";

type LongRoleTileProps = {
  iconClass: string;
  title: string;
  description: string;
};

export default function LongRoleTile({
  iconClass,
  title,
  description,
}: LongRoleTileProps) {
  return (
    <ContentCard kind="bordered">
      <Row gapSize="s">
        <Row.Item shrink>
          <div
            className={`nds-icon-button nds-icon-button--themed ${styles.IconWrapper}`}
          >
            <span
              className={`${iconClass} ${styles.accountsIcon}`}
              aria-hidden="true"
            />
          </div>
        </Row.Item>
        <Row.Item>
          <div className={styles.accountsTitle}>{title}</div>
          <p>{description}</p>
        </Row.Item>
      </Row>
    </ContentCard>
  );
}
